import { Config } from '../../config/config';

export const PWA_SERVICE_WORKER_URL = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

/** Keep in sync with `$pwa-install-banner-height` in `styles/pwa-standalone.scss`. */
export const PWA_INSTALL_BANNER_HEIGHT_PX = 44;

export const PWA_INSTALL_BANNER_VISIBLE_CLASS = 'pwa-install-banner-visible';

/** Message type posted to the service worker with brand values from Config. */
export const PWA_BRAND_MESSAGE_TYPE = 'PWA_BRAND';

/** PWA icon filenames under `PWA_ICONS_BASE_URL` (or same-origin `/icons/` fallback). */
export const PWA_ICON_192 = 'icon-192.png';
export const PWA_ICON_512 = 'icon-512.png';
export const PWA_ICON_APPLE_TOUCH = 'apple-touch-icon.png';
export const PWA_ICON_BADGE = 'badge-96.png';

/** Theme color — always from brand Config (never hardcode per brand). */
export const PWA_THEME_COLOR = Config.GLOBAL_PRIMARY_COLOR;

export interface IPwaBrandConfig {
    siteName: string;
    siteDomain: string;
    themeColor: string;
    icon192Url: string;
    badgeUrl: string;
}

/**
 * Resolves a PWA icon URL. Prefer absolute brand CDN/admin base; fall back to `/icons/`.
 * Keep in sync with `public/manifest.json` (brand package) icon `src` values.
 */
export function getPwaIconUrl(fileName: string, iconsBaseUrl?: string): string {
    const base = (iconsBaseUrl || '').trim().replace(/\/$/, '');
    if (base) {
        return `${base}/${fileName}`;
    }
    return `${process.env.PUBLIC_URL || ''}/icons/${fileName}`;
}

/**
 * Brand payload for the service worker (push icon/title fallback).
 * Source of truth: `Config.GLOBAL_*` + `Config.PWA_ICONS_BASE_URL`.
 */
export function getPwaBrandConfig(): IPwaBrandConfig {
    return {
        siteName: Config.GLOBAL_SITE_NAME,
        siteDomain: Config.GLOBAL_SITE_DOMAIN,
        themeColor: Config.GLOBAL_PRIMARY_COLOR,
        icon192Url: getPwaIconUrl(PWA_ICON_192, Config.PWA_ICONS_BASE_URL),
        badgeUrl: getPwaIconUrl(PWA_ICON_BADGE, Config.PWA_ICONS_BASE_URL),
    };
}

/**
 * Top install-banner copy — must mention the download bonus explicitly (client request).
 * Keep short: banner uses a single line with ellipsis on narrow phones.
 */
export function getPwaInstallBannerText(bonusCoins: number, coinLabel: string): string {
    const coins = Number.isFinite(bonusCoins) && bonusCoins > 0 ? Math.floor(bonusCoins) : 0;
    const label = (coinLabel || 'Coins').trim() || 'Coins';
    if (coins > 0) {
        return `App installieren & +${coins} ${label} Bonus holen`;
    }
    return 'App installieren & Bonus holen';
}
